<!-- ── Header ─────────────────────────────────────────────────────────────── -->
<div class="modal-header ci-guide-header">
  <span class="ci-guide-title">CI/CD Integration Guide</span>
  <button type="button" class="cicd-close-btn" (click)="activeModal.dismiss()" aria-label="Close">
    <i class="bi bi-x-circle"></i>
  </button>
</div>

<!-- ── Platform tabs ─────────────────────────────────────────────────────── -->
<div class="ci-platform-tabs" *ngIf="!isLoadingPlatforms">
  <button
    *ngFor="let p of platforms"
    type="button"
    class="ci-tab-btn"
    [class.active]="p.value === selectedPlatform"
    (click)="selectPlatform(p.value)">
    {{ p.label }}
  </button>
</div>

<!-- ── Body ──────────────────────────────────────────────────────────────── -->
<div class="ci-guide-body">

  <!-- Initial loading (platforms) -->
  <div class="ci-loading" *ngIf="isLoadingPlatforms">
    <mat-progress-spinner mode="indeterminate" [diameter]="36"></mat-progress-spinner>
    <span>Loading platforms…</span>
  </div>

  <!-- Script loading -->
  <div class="ci-loading" *ngIf="!isLoadingPlatforms && isLoadingScript">
    <mat-progress-spinner mode="indeterminate" [diameter]="36"></mat-progress-spinner>
    <span>Loading guide…</span>
  </div>

  <!-- Two-panel layout -->
  <div class="ci-guide-layout" *ngIf="!isLoadingPlatforms && !isLoadingScript">

    <!-- ── Left nav ──────────────────────────────────────────────────────── -->
    <nav class="ci-guide-nav" aria-label="Guide sections">
      <button
        *ngFor="let item of navItems"
        type="button"
        class="ci-nav-item"
        [class.active]="item.id === activeNavId"
        [class.level-3]="item.level === 3"
        (click)="scrollToSection(item)">
        {{ item.text }}
      </button>
    </nav>

    <!-- ── Right content ─────────────────────────────────────────────────── -->
    <div class="ci-guide-content" #contentPane>
      <div class="ci-guide-html" [innerHTML]="safeHtml"></div>
    </div>

  </div>
</div>

<!-- ── Footer ────────────────────────────────────────────────────────────── -->
<div class="modal-footer ci-guide-footer">
  <div class="ci-footer-script-actions" *ngIf="script">
    <button type="button" class="btn ci-btn-copy" [class.copied]="isCopied" (click)="copyScript()">
      <i class="bi" [class.bi-clipboard]="!isCopied" [class.bi-check2]="isCopied"></i>
      {{ isCopied ? 'Copied' : 'Copy Script' }}
    </button>
    <button type="button" class="btn ci-btn-download" (click)="downloadScript()">
      <i class="bi bi-download"></i> {{ fileName }}
    </button>
  </div>
  <button type="button" class="btn btn-accello-primary-light" (click)="activeModal.dismiss()">
    Close
  </button>
</div>
